"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ticket = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var defaultSize = 12;

function Ticket(_a) {
  var children = _a.children,
      fill = _a.fill,
      _b = _a.size,
      size = _b === void 0 ? defaultSize : _b,
      props = tslib_1.__rest(_a, ["children", "fill", "size"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.08 7.5594L21.71 8.18812C21.8947 8.374 21.9989 8.62489 22 8.88669V10.0643C21.9989 10.3261 21.8947 10.577 21.71 10.7629L10.78 21.7106C10.5937 21.895 10.3423 21.9989 10.08 22H8.9C8.63766 21.9989 8.38626 21.895 8.2 21.7106L7.57 21.0819C7.25592 20.8012 7.15192 20.3542 7.31 19.9641C7.43937 19.6475 7.50397 19.3081 7.5 18.9662C7.5 17.5883 6.38071 16.4713 5 16.4713C4.65733 16.4673 4.31733 16.5318 4 16.6609C3.62054 16.8002 3.19433 16.6978 2.92 16.4014L2.29 15.7727C2.10526 15.5868 2.0011 15.3359 2 15.0741V13.8965C2.0011 13.6347 2.10526 13.3838 2.29 13.1979L13.22 2.29012C13.4063 2.10575 13.6577 2.00181 13.92 2.00071H15.1C15.3568 1.99103 15.6075 2.08037 15.8 2.2502L16.43 2.87892C16.7441 3.15956 16.8481 3.60663 16.69 3.99665C16.5606 4.31334 16.496 4.65265 16.5 4.99462C16.5 6.37252 17.6193 7.48954 19 7.48954C19.3427 7.4935 19.6827 7.42903 20 7.29992C20.3795 7.16056 20.8057 7.26296 21.08 7.5594ZM10 11.9804C10 13.0827 10.8954 13.9763 12 13.9763C13.1046 13.9763 14 13.0827 14 11.9804C14 10.8781 13.1046 9.98446 12 9.98446C10.8954 9.98446 10 10.8781 10 11.9804Z",
    fill: fill
  }));
}

exports.Ticket = Ticket;